export const emailValidatorReg =
    /^[\w+-]+(?:\.[\w+-]+)*@[\w+-]+(?:\.[\w+-]+)*(?:\.[a-zA-Z]{2,4})+$/;
export const emailFormatValidatorRef = /\S+@\S+\.\S+/;
export const nameValidatorReg = /^[a-zA-Z ]+$/;
export const passwordValidatorReg =
    /^((?=.*[0-9])|(?=.*[!@#$%^&]))(?=.*[a-zA-Z])([a-zA-Z0-9!@#$%^&]+).{7,79}$/i;
